import { render, staticRenderFns } from "./ownerExitRoom.vue?vue&type=template&id=02f567f7&scoped=true"
import script from "./ownerExitRoom.vue?vue&type=script&lang=js"
export * from "./ownerExitRoom.vue?vue&type=script&lang=js"
import style0 from "./ownerExitRoom.vue?vue&type=style&index=0&id=02f567f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f567f7",
  null
  
)

export default component.exports